import { ITimeslotsByDay } from '@/shared/interfaces';
import { Optional } from '@/shared/Optional';
import { TimeSlotGridSkeleton } from '@/features/booking/widgets/book-or-queue-up/ui/TimeslotGridSkeleton';
import { R } from '@/features/booking/resources/Texts.resx';
import { Utils } from '@/shared/Utils';

type TimeslotGridProps = {
    isFetchingTimeslots: boolean;
    timeslots: ITimeslotsByDay;
    selectedTimeslot: Optional<Date>;
    onChangeSelectedTimeslot: (date: Date) => void;
};

export const TimeslotGrid = ({
    isFetchingTimeslots,
    timeslots,
    selectedTimeslot,
    onChangeSelectedTimeslot,
}: TimeslotGridProps) => {
    const gridClasses = 'mt-2 grid grid-cols-4 gap-4';
    if (isFetchingTimeslots) {
        return (
            <div className={gridClasses}>
                <TimeSlotGridSkeleton />
            </div>
        );
    }

    const availableSlots = timeslots?.timeslots;

    if (!availableSlots?.length) {
        return (
            <div className="mt-2">{R.NoTimeslotsForCaregiverOnSelectedDay}</div>
        );
    }

    return (
        <div className={gridClasses}>
            {availableSlots.map((slot, index) => {
                const isSelected =
                    selectedTimeslot?.getTime() === slot.getTime();
                const time = Utils.formatTime(slot);
                return (
                    <button
                        key={index}
                        onClick={() => onChangeSelectedTimeslot(slot)}
                        className={`cursor-pointer rounded-lg border py-2 text-center text-sm ${
                            isSelected
                                ? 'text-action border-action'
                                : 'text-secondary border-gray-400 hover:border-gray-600 hover:bg-gray-100'
                        }`}
                    >
                        {time}
                    </button>
                );
            })}
        </div>
    );
};
